<div
  fxLayout="column"
  class="with-padding-large dialog-container"
  fxLayoutGap="8px"
  fxFlex
>
  <mat-label mat-dialog-title translate>
    {{ confirm.title | translate }}
  </mat-label>
  <mat-divider></mat-divider>

  <mat-dialog-content fxFlex>{{
    confirm.message | translate
  }}</mat-dialog-content>
  <div
    class="kmt-toolbar with-horizontal-padding"
    fxLayout="row"
    fxLayoutGap="8px"
    fxLayoutAlign="start center"
  >
    <div class="spacer" fxFlex></div>

    <!-- ✅ If custom buttons exist -->
    <ng-container *ngIf="confirm?.buttons?.length; else defaultButtons">
      <button
        *ngFor="let btn of confirm.buttons"
        type="button"
        mat-flat-button
        mat-stroked-button
        [color]="btn.color || ''"
        [mat-dialog-close]="btn.value"
      >
        {{ btn.text | translate }}
      </button>
    </ng-container>

    <!-- ✅ Fallback (your current behavior) -->
    <ng-template #defaultButtons>
      <button type="button" mat-stroked-button [mat-dialog-close]="false">
        {{ confirm.cancelText | translate }}
      </button>
      <button
        type="button"
        mat-flat-button
        color="primary"
        [mat-dialog-close]="true"
      >
        {{ confirm.okText | translate }}
      </button>
    </ng-template>

    <!-- <button type="button" mat-stroked-button [mat-dialog-close]="false">
      {{ confirm.cancelText | translate }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      [mat-dialog-close]="true"
    >
      {{ confirm.okText | translate }}
    </button> -->
  </div>
</div>
